import Head from "next/head";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import Block, { BlockContent, BlockTopSpacer } from "~/components/Block";
import ButtonSquare from "~/components/ButtonSquare";
import CartAndCheckoutFooter from "~/components/CartAndCheckoutFooter";
import CartWidget from "~/components/CartWidget";
import Title from "~/components/Title";
import theme from "~/styles/theme";

/**
 * Page
 */
function CartPage(props) {
  let { countryData } = props;
  const router = useRouter();

  // @ts-ignore
  const cart = useSelector((state) => state.cart);
  // @ts-ignore
  countryData = useSelector((state) => state.countryData);

  // if(cart,)

  // const cartItems = useCartItems(cart);
  // const { cart, cartItems = [], countryData } = props;
  // const { countryData } = props;
  // const ctpCtx = useContext(CtpCtx);

  // const cartItems = useCartItems(cart);
  const cartItems = cart && !cart.slim ? cart.cartItems : [];

  const handleNextClick = (e) => {
    router.push("/checkout/shipping-address");
  };

  const disableCheckoutButton = !countryData.shipping.enabled || cartItems.length === 0;
  return (
    <>
      <Head>
        <title>Cart | AIAIAI</title>
        <meta name="robots" key="robots" content="noindex" />
      </Head>
      <Block backgroundColor="white" spacingBottom={13} style={{ paddingTop: "5rem" }}>
        <BlockTopSpacer spacing="topBar" />
        <BlockContent>
          {cart && !cart.slim && (
            <CartWidget standalone countryData={countryData}>
              <Title
                type="h1"
                line1={
                  <p>
                    <span>CART</span>
                  </p>
                }
                size={0.5}
              />
            </CartWidget>
          )}
        </BlockContent>
        <CartAndCheckoutFooter standalone>
          <div>
            <div>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  router.push(e.currentTarget.getAttribute("href"));
                }}
              >
                Continue shopping
              </a>
            </div>
            <ButtonSquare
              disabled={disableCheckoutButton}
              onClick={handleNextClick}
              backgroundColor={theme.colors.primary}
              color={theme.colors.dark}
              style={{ fontSize: "0.8rem" }}
            >
              Check out
            </ButtonSquare>
          </div>
          {!countryData.shipping.enabled && (
            <>
              <br />
              <span style={{ color: "#555", textAlign: "center" }}>
                We're terribly sorry, but we're unable to ship to {countryData.name}.
                {countryData.resellers && countryData.resellers.length > 0 && (
                  <>
                    <br />
                    <br />
                    Please visit local reseller{" "}
                    <a href={countryData.resellers[0].url} rel="nofollow">
                      {countryData.resellers[0].name}
                    </a>
                    .
                  </>
                )}
              </span>
            </>
          )}
        </CartAndCheckoutFooter>
      </Block>
    </>
  );
}

CartPage.getInitialProps = async (ctx) => {
  try {
    const { ctpCtx, countryData, store } = ctx;

    /* let cart = store.getState().cart;
    //console.log(cart);

    //console.log('RESOLVING FULL CART?', cart && cart.slim)
    if (!cart || cart.slim) {
      // get cart
      cart = await getMyCart(ctpCtx, cart.id, countryData); //await resolveCart(ctx, false);

      // we have a cart - update store and cookies!
      if (cart) {
        // set cart in store
        store.dispatch(setCart(cart));
        // set view only to false
        store.dispatch(setViewOnlyFalse());

        // get shippingRates and add to store
        const shippingMethods = await getShippingMethodsByCart(ctpCtx, cart.id);
        store.dispatch(setShippingMethods(shippingMethods));
      }
    } */

    return {
      resolveFullCart: true,
      countryData,
    };
  } catch (err) {
    throw err;
  }
};

export default CartPage;
